import { strings } from "../../constants/strings";
import { pickKey } from '../../helpers/keyPicker'
export const NAME = 'DASHBOARD'
export const types = {
  
}

export const initialState = {
  modalIsVisible: false,
  modalTxts: {
    titleTxt: '',
    contentTxt: '',
    botTitleTxt: '',
  },  
  exercises: [
    {
      id: 'wordpairs',
      name: strings.WordPairs_name,
      link: strings.Web_Wordpairs_link
    },
    {
      id: 'letterjumble',
      name: strings.LetterJumble_name,
      link: strings.Web_LetterJumble_link
    },
    {
      id: 'numbersinput', //numbers
      name: strings.NumbersInput_name,
      link: strings.Web_NumbersInput_link, //do not exist
      accessibility: 'unavailable'
    },
    {
      id: 'wordsearch',
      name: strings.WordSearch_name,
      link: strings.Web_Wordsearch_link,
      accessibility: 'premium'
    },
    {
      id: 'schultenumbers',
      name: strings.SchulteNumbers_name,
      link: strings.Web_schultenumbers_link,
      accessibility: 'premium'
    },
    {
      id: 'textsearch',
      name: strings.TextSearch_name,
      link: strings.Web_Textsearch_link, //do not exist
      accessibility: 'unavailable'
    },
    {
      id: 'numbersearch',
      name: strings.NumberSearch_name,
      link: strings.Web_Numbersearch_link, //do not exist
      accessibility: 'unavailable'
    },
    {
      id: 'evennumbers',
      name: strings.EvenNumbers_name,
      link: strings.Web_Evennumbers_link, //do not exist
      accessibility: 'unavailable'
    },
    {
      id: 'schulteletters',
      name: strings.SchulteLetters_name,
      link: strings.Web_schulteletters_link,
      accessibility: 'premium'
    },
    {
      id: 'lettermixup',
      name: strings.LetterMixup_name,
      link: strings.Web_Lettermixup_link, //do not exist
      accessibility: 'unavailable'
    },
    {
      id: 'schultemix',
      name: strings.SchulteMix_name,
      link: strings.Web_schultemix_link,
      accessibility: 'premium'
    },
    {
      id: 'wordsinput',  //words
      name: strings.WordsInput_name,
      link: strings.Web_Wordsinput_link, //do not exist
      accessibility: 'unavailable'
    },
    {
      id: 'sentencesinput', //sentences
      name: strings.SentencesInput_name,
      link: strings.Web_Sentencesinput_link, //do not exist
      accessibility: 'unavailable'
    },
    {
      id: 'wpmtest',
      name: strings.WPMTest_name,
      link: strings.Web_Wpmtest_link,
      accessibility: 'premium'
    },
    {
      id: 'comprehension',
      name: strings.Comprehension_name,
      link: strings.Web_Comprehension_link, //do not exist
      accessibility: 'unavailable'
    }
  ]
}

export function reducer(state = initialState, action) {
  switch (action.type) {
    case "INIT_EXERCISES": {
      return {
        ...state,
        exercises: action.exercises
      }
    }
    case "SHOW_CURICULUM": {
      return {
        ...state,
        modalTxts: {
          titleTxt: strings.Dashboard_popup_curriculum_title,
          contentTxt: strings.Dashboard_popup_all_text1,
          botTitleTxt: strings.Dashboard_popup_all_text2,
          amazonBtnClass: 'amazon-curric',
          googleBtnClass: 'google-curric',
          appleBtnClass: 'apple-curric'
        },
        modalIsVisible: true
      }
    }
    case "SHOW_POWER_READER": {
      return {
        ...state,
        modalTxts: {
          titleTxt: strings.Dashboard_popup_PoweReader_title,
          contentTxt: strings.Dashboard_popup_all_text1,
          botTitleTxt: strings.Dashboard_popup_all_text2,
          amazonBtnClass: 'amazon-power',
          googleBtnClass: 'google-power',
          appleBtnClass: 'apple-power'
        },
        modalIsVisible: true
      }
    }
    case "SHOW_PREMIUM_LOCKED": {
      return {
        ...state,
        modalTxts: {
          isPremiumModal: true,
          titleTxt: pickKey('Subscriptions_Description'),
          contentTxt: [strings.Subscription_Checkmark1_Title,strings.Subscription_Checkmark2_Title,strings.Subscription_Checkmark3_Title],
          buttonTxt: strings.Subscription_Premium_Title,
          amazonBtnClass: 'unlock-pr-popup'
        },
        modalIsVisible: true
      }
    }
    case "SHOW_LOCKED_MODAL": {
      return {
        ...state,
        modalTxts: {
          titleTxt: action.txt1,
          contentTxt: action.txt2,
          botTitleTxt: action.txt3,
          amazonBtnClass: 'amazon-ex-popup',
          googleBtnClass: 'google-ex-popup',
          appleBtnClass: 'apple-ex-popup',
        },
        modalIsVisible: true
      }
    }
    case "SHOW_MODAL": {
      return {
        ...state,
        modalIsVisible: true
      }
    }
    case "HIDE_MODAL": {
      return {
        ...state,
        modalIsVisible: false
      }
    }
    default:
      return { ...state }
  }
}
